var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDefaultAvataricon = function SvgDefaultAvataricon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 231 232"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 231,
    height: 232,
    fill: "url(#default-avatar_icon_svg__a)",
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#default-avatar_icon_svg__b)",
    d: "M38.234 179.911c0-25.774 51.68-39.949 77.537-39.949 25.856 0 77.536 14.175 77.536 39.949v12.887H38.25m116.281-116a38.62 38.62 0 0 1-11.359 27.347 38.83 38.83 0 0 1-27.417 11.33 38.8 38.8 0 0 1-27.417-11.33 38.6 38.6 0 0 1-11.36-27.347 38.6 38.6 0 0 1 11.36-27.347c7.28-7.262 17.157-11.314 27.433-11.314a38.82 38.82 0 0 1 27.417 11.33 38.6 38.6 0 0 1 11.343 27.331"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "default-avatar_icon_svg__a",
    x1: 55.248,
    x2: 213.01,
    y1: 0,
    y2: 114.459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "default-avatar_icon_svg__b",
    x1: 14.779,
    x2: 270.733,
    y1: -17.044,
    y2: 116.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#494C74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707,
    stopColor: "#1B1E25"
  })))));
};
export default SvgDefaultAvataricon;